import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getCmsList, getCmsEntry, createCms, updateCms } from '@/api/cms';
import type { CmsListParams, CreateCmsPayload, UpdateCmsPayload } from '@/_types';

export function useGetCmsList(params?: CmsListParams) {
  return useQuery({
    queryKey: ['cms', params],
    queryFn: () => getCmsList(params),
  });
}

export function useGetCmsEntry(id: string) {
  return useQuery({
    queryKey: ['cms', id],
    queryFn: () => getCmsEntry(id),
    enabled: !!id,
  });
}

export function useCreateCms() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateCmsPayload) => createCms(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cms'] });
    },
  });
}

export function useUpdateCms(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateCmsPayload) => updateCms(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cms', id] });
      qc.invalidateQueries({ queryKey: ['cms'] });
    },
  });
}
